
import React, { useEffect,useState,lazy } from 'react';
import { Table, TableBody, TableContainer, TableHead, TableRow, TableCell, Box, Paper } from '@mui/material';
import BreadcrumbHeader from 'ui-component/BreadcrumbHeader';
import AsyncTableListing from 'ui-component/AsyncTableListing';
import { makeStyles } from '@mui/styles';
import {ExportLiveDeals,FetchDashboardDealsData } from 'api';
import CustomButton from 'ui-component/CustomButton';
import Cookies from 'js-cookie';
import Loadable from 'ui-component/Loadable';
import Loading from 'views/Loading';

const useStyles = makeStyles((theme) => ({
    customTable: {
        '& td.MuiTableCell-root': { padding: '10px 16px 10px 16px' },
        '& .MuiTableCell-head': {
            color: 'white',
            backgroundColor: theme.palette.table.header
        }
    }
}));
const LiveDealsSummary = () => {
    const [title, setTitle] = useState('Live Deals Summary');
    const classes = useStyles();
    const [isExportLoading, setIsExportLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [reportModule, setReportModule] = useState(null); // Define the state
  const Error404 = Loadable(lazy(() => import('views/error/Error404')));
    const excel_report = "excel_report";
    // const { isLoading: isDashDataLoading, data: dashData } = FetchVenturePartners();
    const { refetch: refetchExportVenturePartners, isLoading: isExportVenturePartners,isRefetching: isExportVenturePartnersRefetching } = ExportLiveDeals(excel_report);
    const { isLoading: isDashDealDataLoading, data: dashDealsData } = FetchDashboardDealsData()
    useEffect(() => {
        const permission_values = localStorage.getItem('permission');
        const permissions = permission_values != undefined ?  JSON.parse(permission_values) : [];
        // console.log(permissions,"say");
        const module = permissions.find(
          (module) => module.module_name === 'reports' && module.permisson === true
        );
        setReportModule(module); // Set the value in the state
      }, []);
    function handleSearch() {
        if (dashDealsData.data && searchQuery !== null && searchQuery !== undefined) {
            const filteredData = dashDealsData.data.filter((partner) =>
                (partner.scheme_name && partner.scheme_name.toLowerCase().includes(searchQuery.toLowerCase()))
                // (partner.representative_name && partner.representative_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                // (partner.venture_partner_name && partner.venture_partner_name.toLowerCase().includes(searchQuery.toLowerCase()))
            );
            return filteredData;
        }
        return [];
    }

    
    function download() {
        setIsExportLoading(true);
        refetchExportVenturePartners()
          .then(({ data }) => {
            setIsExportLoading(false);
      
            const link = document.createElement('a');
            link.href = data.url;
            link.target = '_blank';   
            link.setAttribute('download', 'filename.xlsx'); // Specify the desired filename here
            link.click();
          })
      } 
    
    return (
        (reportModule != undefined  && reportModule.vp_investment == true) ?
        <>
            <Box sx={{ width: '100%' }}>
                <BreadcrumbHeader title={title} />
            </Box>
            <div className='custom-menu-block view-investor-block'>
                <div className='d-flex mb-3'>
                    <div>
                        <input type='text' className='form-control' placeholder='Search'
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                         />
                    </div>
                    <div className='ms-3'>
                        <button className='button-79' type='button' onClick={handleSearch}>Search</button>
                    </div>
                </div>
                <div className='custom-table vp-investment-dtl-table'>
                <Paper sx={{ width: '100%' }}>
                    <TableContainer sx={{ maxHeight: "calc(100vh - 300px)",borderRadius: '8px' }}>
                        {/* , border: 1, borderColor: 'rgba(224, 224, 224, 1)' */}
                        <Table className={`${classes.customTable} add-border remove-border-collapse`} aria-label="customized table"  >
                            <TableHead sx={{position: 'sticky', top: '-1px'}}>
                                {/* <TableRow
                                    sx={{
                                        '& .MuiTableCell-sizeMedium': {
                                            padding: '10px 16px 10px 16px' // <-- arbitrary value
                                        }
                                    }}
                                >
                                    <TableCell colSpan={10} className='text-center'  style={{ top: 1, borderBottom: "1px solid rgb(213 213 213 / 30%)"}}>Live Deal Summary</TableCell>
                                </TableRow> */}
                                <TableRow
                                    sx={{
                                        '& .MuiTableCell-sizeMedium': {
                                            padding: '10px 16px 10px 16px' // <-- arbitrary value
                                        }
                                    }}
                                >
                                    <TableCell style={{ top: 52}}>Deal Name</TableCell>
                                    <TableCell style={{ top: 52}}> Investors Count</TableCell>
                                    <TableCell style={{ top: 52}}>Total Interest Shown (₹)</TableCell>
                                    <TableCell style={{ top: 52}}>Investment Count</TableCell>
                                    <TableCell style={{ top: 52}}>Total Received (₹)</TableCell>
                                    <TableCell style={{ top: 52}}>Created Date</TableCell>
                                    <TableCell style={{ top: 52}}>Deal Showcase</TableCell>
                                    <TableCell style={{ top: 52}}>Moved to interest</TableCell>
                                    <TableCell style={{ top: 52}}>Moved to call for money</TableCell>
                                </TableRow>
                            </TableHead>
                            {searchQuery.trim() === '' ? (
                               <TableBody>
                                {dashDealsData?(
                                    dashDealsData.data.map((partner, index) => (
                                <tr key={index}>
                                    <td>{partner.scheme_name}</td>
                                    <td>{partner.interested_count}</td>
                                    <td>{partner.interested_amount}</td>
                                    <td>{partner.investment_count}</td>
                                    <td>{partner.investment_amount}</td>
                                    <td>{partner.created_date}</td>
                                    <td>{partner.meeting_date}</td>
                                    <td>{partner.move_interest_date}</td>
                                    <td>{partner.move_call_money_date}</td>
                                </tr>
                                ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" align="center">
                                            
                                             <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Loading /></div>
                                        
                                        </td>
                                    </tr>
                                )}
                                
                               </TableBody>
                            ) : (
                             <TableBody>
                                {handleSearch().length > 0 ? (
                            handleSearch().map((partner, index) => (
                                <TableRow key={index}>
                                    <TableCell>{partner.scheme_name}</TableCell>
                                    <TableCell>{partner.interested_count}</TableCell>
                                    <TableCell>{partner.interested_amount}</TableCell>
                                    <TableCell>{partner.investment_count}</TableCell>
                                    <TableCell>{partner.investment_amount}</TableCell>
                                    <TableCell>{partner.created_date}</TableCell>
                                    <TableCell>{partner.meeting_date}</TableCell>
                                    <TableCell>{partner.move_interest_date}</TableCell>
                                    <TableCell>{partner.move_call_money_date}</TableCell>
                                </TableRow>
                            ))
                                ) : (
                                <TableRow>
                                 <TableCell colSpan={10}>No matching records found.</TableCell>
                                </TableRow>
                                )}
                             </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                    </Paper>
                    <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right',marginTop: '10px' }}>
                       <CustomButton
                         onClick={download}
                         size="medium"
                         loading={isExportLoading}
                         sx={{ height: '40px', marginRight: '10px' }} 
                        >
                         Export As Excel
                        </CustomButton>
                    </div>
                    <table className='w-100'>
                        <thead>

                        </thead>
                        <tbody>

                        </tbody>
                    </table>
                </div>
            </div>
        </>
        :    <Error404 />
    )
}

export default LiveDealsSummary